export const signUp = ({ user }) => user.signUp;
export const supplierSignUp = ({ user }) => user.supplierSignUp;
export const forgotPassword = ({ user }) => user.forgotPassword;
export const profile = ({ user }) => user.profile;
export const currentUser = ({ user }) => user.user;
